// init.client.ts のグローバル popstate リスナーと
// BrowserBackUnsavedGuard コンポーネント間で共有する状態。
// モジュールレベルの mutable object として保持し React の外から直接書き換える。

export const guardState = {
  // ガードが有効かどうか（warnWhen と同期）
  isActive: false,
  // 次の popstate を素通りさせるフラグ（confirm OK/cancel 後の history.go() による popstate を通す）
  suppressNext: false,
  // グローバルリスナーが追跡する history.state.idx（遷移方向判定に使用）
  lastIdx: null as number | null,
  // confirm ダイアログのメッセージ
  message: '',
};
